export const elementCodeNormalizer = (str: string): string => {
	const code = str.replace(/[^a-zA-Z0-9_]+/g, '_');
	return code.replace(/^[^a-zA-Z0-9]*|[^a-zA-Z0-9]*$/g, '');
};
